import React from 'react';
import { useSelector } from 'react-redux';
import ApplicationHeader from './ApplicationHeader';
import ApplicationList from './ApplicationList';

const Applications = () => {
  const total = useSelector((state) => state.integration_application.totalRows);

  return (
    <div className="tw-space-y-4">
      <ApplicationHeader total={total} />
      <ApplicationList />
    </div>
  );
};

export default Applications;
